<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <card card-body-classes="table-full-width px-3">
          <div slot="header">
            <h4 class="card-title f-20-mobile">Vendas por Pagamentos do Período {{data_inicio_cabecalho}} à {{data_fim_cabecalho}}</h4>
          </div>
          <div class="row">
            <p class="bg-warning btn-round text-white col-md-12" id="error_data" style="display:none">A data selecionada não é uma data valida</p>
            <input type="date" class="form-control mx-2 mx-auto-mobile my-2-mobile" style="max-width: 220px" @change="verificaData(data_inicio)" v-model="data_inicio">
            <input type="date" class="form-control mx-2 mx-auto-mobile my-2-mobile" style="max-width: 220px" @change="verificaData(data_fim)" v-model="data_fim">
            <select v-if="moduloRelatorioUsuario" class="form-control mx-2 mx-auto-mobile my-2-mobile" style="max-width: 220px" v-model="usuario_cabecalho">
              <option value="">Selecione um usuario...</option>
              <option v-for="usuario of usuarios" :value="usuario.codigo">{{ usuario.nome }}</option>
            </select>
            <n-button type="primary" class="btn btn-round btn-wd btn-info mx-auto-mobile mb-2-mobile " v-on:click.native="filtrar" style="height:30px;margin-left: 20px;padding:0;margin-top:0;">Filtrar</n-button>
          </div>


          <div class="mb-3">
            <div v-for="venda of vendas" class="row py-2 px-2 bordered-block-table only-mobile">
              <div class="col-6">
                <strong>{{ venda.nome }}</strong>
                <br>
                Código {{ venda.codigo }}
              </div>
              <div class="col-6">
                Qtd: {{ venda.qtd }}
                <br>
                {{ venda.count | currencyBrl(true)}}
              </div>
            </div>

            <div class="row py-2 px-2 bordered-block-table only-mobile">
              <div class="col-6">
                <strong>Total Qtd:</strong>
                <br>
                <strong>Total:</strong>
                <br>
                <strong>Total Taxa:</strong>
              </div>
              <div class="col-6">
                Qtd: {{ totais.qtd }}
                <br>
                {{ totais.count | currencyBrl(true) }}
                <br>
                {{ totais.taxa | currencyBrl(true) }}
              </div>
            </div>
          </div>


          <table class="display responsive nowrap table table-hover table-striped table-bordered hidden-mobile">
            <thead>
              <tr>
                <th>Código</th>
                <th>Nome</th>
                <th>Quantidade</th>
                <th>Valor de Taxa</th>
                <th>Faturado</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="venda of vendas">
                <td>{{ venda.codigo }}</td>
                <td>{{ venda.nome }}</td>
                <td>{{ venda.qtd }}</td>
                <td>{{ venda.taxa | currencyBrl(true)}}</td>
                <td>{{ venda.count | currencyBrl(true)}}</td>
              </tr>
              <tr v-if="!vendas">
                <td class="text-center" colspan="5">Nenhum resultado encontrado</td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td>Total</td>
                <td></td>
                <td>{{totais.qtd}}</td>
                <td>{{totais.taxa | currencyBrl(true)}}</td>
                <td>{{totais.count | currencyBrl(true)}}</td>
              </tr>              
            </tfoot>
          </table>
        </card>
      </div>
      <div class="card" style="margin:0 15px 0 15px" align="center">
      <div class="card-body col-md-12" >
        <pie-chart
          :chart-data="chartData" 
          :options="chartOptions"
          :height="200"
        ></pie-chart>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import {
    Card,
    AnimatedNumber,
    PieChart
  } from 'src/components'
  import { Chart } from 'chart.js';
  import { setInterval } from 'timers';
  import { EventBus } from '@/services/EventBus'
  import {Table, TableColumn} from 'element-ui'
  import moment from 'moment'
  import jQuery from 'jquery'
  import GlobalFunctions from '../../../globalFunctions.js'
  import VendaService from '@/services/VendaService.js'
  import UsuarioService from '@/services/UsuarioService.js'

  export default {
    components: {
      Card,
      AnimatedNumber,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      moment,
      PieChart
    },
    data() {
      return {
        data_inicio: moment().format("YYYY-MM-DD"),
        data_fim: moment().format("YYYY-MM-DD"),
        data_fim_cabecalho:moment().format("DD/MM/YYYY"),
        data_inicio_cabecalho:moment().format("DD/MM/YYYY"),
        mobile:GlobalFunctions.isMobile(),
        vendas: [],
        usuarios: [],
        usuario_cabecalho: "",
        chartData: {},
        moduloRelatorioUsuario: localStorage.getItem('config_modulo_relatorio_usuario') == "true" ? true : false,
        chartOptions: {
          tooltips: {
            callbacks: {
              label: function(tooltipItems, data) {
                // Percentage
                var dataset = data.datasets[tooltipItems.datasetIndex];
                var meta = dataset._meta[Object.keys(dataset._meta)[0]];
                var total = meta.total;
                var currentValue = dataset.data[tooltipItems.index];
                var percentage = parseFloat((currentValue/total*100).toFixed(1));

                return data.labels[tooltipItems.index] + ": R$ " + data.datasets[0].data[tooltipItems.index] + "  (" + percentage + "%)";
              }
            }
          },
        },
        totais:{},
      }
    },
    methods: {
      filtrar() {
        this.data_fim_cabecalho = moment(this.data_fim).format('DD/MM/YYYY');
        this.data_inicio_cabecalho = moment(this.data_inicio).format('DD/MM/YYYY');
        this.loadVendas()
      },
      verificaData(data) {
        let data_formatada = new Date(data);
        if(data_formatada == 'Invalid Date'){
          jQuery('#error_data').show();
        }else{
          jQuery('#error_data').hide();
        }
      },
      loadVendas() {
        let params = `?data_inicio=${this.data_inicio}&data_fim=${this.data_fim}&page=${this.current_page}`;

        if(this.usuario_cabecalho != "") {
          params += `&usuario=${this.usuario_cabecalho}`
        }

        let loader = this.$loading.show();

        VendaService.loadChartPagamentos(params).then(res => {
          this.totais = res.data.totais;
          this.vendas = res.data.table;

          this.chartData = {
            labels: res.data.labels,
            datasets: [{
              data: res.data.data,
              backgroundColor: [
                GlobalFunctions.corAleatoria(),
                GlobalFunctions.corAleatoria(),
                GlobalFunctions.corAleatoria(),
                GlobalFunctions.corAleatoria(),
                GlobalFunctions.corAleatoria(),
                GlobalFunctions.corAleatoria(),
                GlobalFunctions.corAleatoria(),
                GlobalFunctions.corAleatoria(),
              ],
            },]
          }

          loader.hide()
        }).catch(err => {
          loader.hide()
        })
      },
      loadUsers(){
        UsuarioService.load().then(res => {
          this.usuarios = res.data
        })  
      },
    },
    mounted(){
      this.loadUsers()
      this.loadVendas()

      EventBus.$on('moduloRelatorioUsuario', res => {
        if(res == "true") {
          this.moduloRelatorioUsuario = true;
        } else {
          this.moduloRelatorioUsuario = false;
        }
      })
    }
}
</script>


<style>
  
</style>